import {pick} from "../../utils/utils";
import {Sizes} from "../../core/constants/sizes";
import {ValueOf} from "../../types/interfaces";

export const TileSizes = pick(Sizes, ['_S', '_M', '_L'])
export type TileSizesType = `${ValueOf<typeof TileSizes>}`

export const TileClass = {
	root: 'gov-tile',
	link: 'gov-tile__link',
	content: 'gov-tile__content',
	text: 'gov-tile__text',
	title: 'gov-tile__title',
	icon: 'gov-tile__icon',
	annotation: 'gov-tile__annotation',
}
